export class FontLoader
{
  private static readonly GEOLOGICA_WEIGHTS = [200, 300, 400, 600, 700, 800, 900];

  public static async preloadAll(): Promise<void>
  {
    const fonts = ( document as any ).fonts as FontFaceSet | undefined;
    if ( !fonts )
      return;

    const specs = this.GEOLOGICA_WEIGHTS.map( weight => `${weight} 16px Geologica` );

    await Promise.all( specs.map( spec => fonts.load( spec ).catch( () => [] ) ) );
    await fonts.ready;
  }
}
